import { createBrowserRouter } from 'react-router-dom';

import { MainLayout, PublicLayout } from '../components/Layout';
import { AuthGuard } from '../components';
import { LoginPage } from '../views/auth';
import { HomePage } from '../views/home';
// import { KanbanUI as KanbanPage } from '../views/kanban/ui';
import { ProgressiveDemandForm } from '../views/demands/ui/ProgressiveDemandForm';
import { UnifiedDemandsPage } from '../views/demands-unified-old';
import { DemandViewPage } from '../views/demand-view';
import { ProcessesAndSectorsPage } from '../views/processes';
import { ButtonsPage, InputsPage, CardsPage, ModalsPage, SelectsPage, TextareasPage, BadgesPage, TablesPage, FloatingToolbarPage } from '../views/viewscomp';
import { CollaboratorsPage } from '../views/collaborators';
import { NotificationsPage } from '../views/notifications';
import { CalendarPage } from '../views/calendar';
import { ChangelogPage } from '../views/changelogs/ui';
import { Error404Page, Error502Page, Error503Page } from '../views/errors';
// Templates - Páginas de acesso rápido
import { SolicitacaoAcessoSistemaPage } from '../views/templates/pages/SolicitacaoAcessoSistemaPage';
import { SolicitacaoCriacaoAcessoInstitucionalPage } from '../views/templates/pages/SolicitacaoCriacaoAcessoInstitucionalPage';

export const useAppRouter = () => {
  const router = createBrowserRouter([
    // Rotas principais (com sidebar e autenticação)
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: '',  // Rota raiz
          element: <HomePage />,
          handle: { crumbs: { title: 'Dashboard' } },
        },
        
        // Rota do Kanban
        // {
        //   path: 'kanban',
        //   element: <KanbanPage />,
        //   handle: { crumbs: { title: 'Kanban' } },
        // },
        
        // Rotas de demandas
        {
          path: 'demands',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Todas as Demandas' } },
        },
        {
          path: 'demands/new',
          element: <ProgressiveDemandForm />,
          handle: { crumbs: { title: 'Nova Demanda' } },
        },
        {
          path: 'demands/received',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas Recebidas' } },
        },
        {
          path: 'demands/sent',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas Enviadas' } },
        },
        {
          path: 'demands/watching',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas Observáveis' } },
        },
        {
          path: 'demands/toAssign',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas em Atribuição' } },
        },
        {
          path: 'demands/authorization',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Autorizações Pendentes' } },
        },
        {
          path: 'demands/waitingAuth',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Aguardando Autorização' } },
        },
        {
          path: 'demands/inProgress',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas em Andamento' } },
        },
        {
          path: 'demands/solved',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas Solucionadas' } },
        },
        {
          path: 'demands/finished',
          element: <UnifiedDemandsPage />,
          handle: { crumbs: { title: 'Demandas Finalizadas' } },
        },
        {
          path: 'demands/:id/view',
          element: <DemandViewPage />,
          handle: { crumbs: { title: 'Visualizar Demanda' } },
        },
        
        // Rotas de templates de acesso rápido
        {
          path: 'templates/acesso-sistema',
          element: <SolicitacaoAcessoSistemaPage />,
          handle: { crumbs: { title: 'Solicitar Acesso ao Protheus' } },
        },
        {
          path: 'templates/acesso-institucional',
          element: <SolicitacaoCriacaoAcessoInstitucionalPage />,
          handle: { crumbs: { title: 'Cadastrar Acesso Institucional' } },
        },
        
        // Rotas de gestão
        {
          path: 'collaborators',
          element: <CollaboratorsPage />,
          handle: { crumbs: { title: 'Colaboradores' } },
        },
        {
          path: 'notificacoes',
          element: <NotificationsPage />,
          handle: { crumbs: { title: 'Notificações' } },
        },
        {
          path: 'calendar',
          element: <CalendarPage />,
          handle: { crumbs: { title: 'Calendário' } },
        },
        {
          path: 'changelog',
          element: <ChangelogPage />,
          handle: { crumbs: { title: 'Histórico de Atualizações' } },
        },
        
        // Rotas de Gestão (unified structure)
        {
          path: 'gestao/processos',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Gestão de Processos' } },
        },
        {
          path: 'gestao/processos/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Processo' } },
        },
        {
          path: 'gestao/processos/edit',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Editar Processo' } },
        },
        {
          path: 'gestao/setores',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Gestão de Setores' } },
        },
        {
          path: 'gestao/setores/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Setor' } },
        },
        {
          path: 'gestao/setores/edit',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Editar Setor' } },
        },
        {
          path: 'gestao/equipes',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Gestão de Equipes' } },
        },
        {
          path: 'gestao/equipes/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Equipe' } },
        },
        {
          path: 'gestao/equipes/edit',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Editar Equipe' } },
        },
        {
          path: 'gestao/autorizadores',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Gestão de Autorizadores' } },
        },
        {
          path: 'gestao/autorizadores/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Autorizador' } },
        },
        {
          path: 'gestao/autorizadores/edit',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Editar Autorizador' } },
        },
        {
          path: 'gestao/sistemas',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Gestão de Sistemas' } },
        },
        {
          path: 'gestao/sistemas/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Sistema' } },
        },
        {
          path: 'gestao/sistemas/edit',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Editar Sistema' } },
        },
        
        // Legacy routes (keep for backwards compatibility)
        {
          path: 'processes/new',
          element: <ProcessesAndSectorsPage />,
          handle: { crumbs: { title: 'Criar Processo' } },
        },
        
        {
          path: 'reports',
          element: <HomePage />,
          handle: { crumbs: { title: 'Relatórios' } },
        },
        {
          path: 'settings',
          element: <HomePage />,
          handle: { crumbs: { title: 'Configurações' } },
        },

        // Rotas de componentes (para demonstração)
        {
          path: 'components',
          element: <ButtonsPage />,
          handle: { crumbs: { title: 'Componentes' } },
        },
        {
          path: 'components/buttons',
          element: <ButtonsPage />,
          handle: { crumbs: { title: 'Componentes - Buttons' } },
        },
        {
          path: 'components/inputs',
          element: <InputsPage />,
          handle: { crumbs: { title: 'Componentes - Inputs' } },
        },
        {
          path: 'components/selects',
          element: <SelectsPage />,
          handle: { crumbs: { title: 'Componentes - Selects' } },
        },
        {
          path: 'components/cards',
          element: <CardsPage />,
          handle: { crumbs: { title: 'Componentes - Cards' } },
        },
        {
          path: 'components/modals',
          element: <ModalsPage />,
          handle: { crumbs: { title: 'Componentes - Modals' } },
        },
        {
          path: 'components/textarea',
          element: <TextareasPage />,
          handle: { crumbs: { title: 'Componentes - Textarea' } },
        },
        {
          path: 'components/badges',
          element: <BadgesPage />,
          handle: { crumbs: { title: 'Componentes - Badges' } },
        },
        {
          path: 'components/tables',
          element: <TablesPage />,
          handle: { crumbs: { title: 'Componentes - Tables & Badges' } },
        },
        {
          path: 'components/floating-toolbar',
          element: <FloatingToolbarPage />,
          handle: { crumbs: { title: 'Componentes - Floating Toolbar' } },
        },
      ],
    },

    // Rotas públicas (sem sidebar)
    {
      path: '/login',
      element: <LoginPage />,
    },
    
    // Easter Egg - DESATIVADO (só pode ser acessado via Ctrl+Alt+D -> E -> V)
    // {
    //   path: '/dev-team',
    //   element: (
    //     <AuthGuard>
    //       <DevelopersPage />
    //     </AuthGuard>
    //   ),
    // },
    
    {
      path: '/errors',
      element: <PublicLayout />,
      children: [
        {
          path: '404',
          element: <Error404Page />,
          handle: { crumbs: { title: 'Página não encontrada' } },
        },
        {
          path: '502',
          element: <Error502Page />,
          handle: { crumbs: { title: 'Erro do servidor' } },
        },
        {
          path: '503',
          element: <Error503Page />,
          handle: { crumbs: { title: 'Serviço indisponível' } },
        },
      ],
    },

    // Rota catch-all para 404
    {
      path: '*',
      element: <Error404Page />,
    },
  ]);

  return router;
};
